// extracted by mini-css-extract-plugin
export var description = "c6Xdw";
export var fullRow = "pYntw";
export var image = "dIvn4";
export var main = "XuAUI";